import Inspector from './inspector';
const { RichText } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { title, subtitle, text, image, drop } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div
        className={`${
          drop ? 'CardsDropdown-accordion-item' : 'CardsDropdown-normal-item'
        }`}
        style={{ backgroundImage: `url(${image.src})` }}
      >
        <div className="CardsDropdown-accordion-item-title">
          {!drop && (
            <RichText
              tagName="h4"
              value={subtitle}
              className="Typography caption color-white margin-none left"
              placeholder="subtitulo"
              keepPlaceholderOnFocus
              onChange={(subtitle) => setAttributes({ subtitle })}
            />
          )}

          <RichText
            tagName="h3"
            value={title}
            className="Typography text color-white margin-none left"
            placeholder="Título"
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />

          {drop && (
            <>
              <span>Mais</span>
              <i className="icon icon-keyboard_arrow_down"></i>
            </>
          )}
        </div>
      </div>

      {drop && (
        <div className="CardsDropdown-accordion-item-content wp-edit">
          <RichText
            tagName="p"
            value={text}
            className="Typography text left margin-none color-grey"
            placeholder="Texto"
            keepPlaceholderOnFocus
            onChange={(text) => setAttributes({ text })}
          />
        </div>
      )}
    </>
  );
};

export default Edit;
